var _effectorFileName = "/builds/gmini/front-common/src/Explorer/explorer.context.ts";
import { createCtxProvider } from "./ctx/ctx";

var _createCtxProvider = createCtxProvider(),
    TreeContextMenuProvider = _createCtxProvider.TreeContextMenuProvider,
    useNodeCtxMenu = _createCtxProvider.useNodeCtxMenu;

export { TreeContextMenuProvider, useNodeCtxMenu };